import { render, staticRenderFns } from "./MentionText.vue?vue&type=template&id=4605812b&scoped=true&"
import script from "./MentionText.vue?vue&type=script&lang=ts&"
export * from "./MentionText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605812b",
  null
  
)

export default component.exports